var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":`modal-add-categories-products`,"title":_vm.$t('add'),"size":"lg","static":"","centered":"","hide-footer":""}},[_c('FormCategoryProductTreeSelect',{attrs:{"group-id":_vm.groupId,"disabled-nodes":_vm.usedIds,"disabled":_vm.parentComponent.loading},on:{"added":_vm.handleAdded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }